module.exports = __webpack_public_path__ + "img/cg.7f749cab.png";